export default "__VITE_ASSET__oNCm6sHs__"